import { IconChatSupport } from "@resources/icons/Icons";
// import { HVIcon } from "@repo/HVComponents";
import * as S from "./Card.styled";
// import { ICON } from "../../../constants/icons";

interface CardProps {
  title: string;
  desc: string;
  onSendChat: (msg: string) => void;
}

const Card = ({ title, desc, onSendChat }: CardProps) => {
  return (
    <S.CardWrapper onClick={() => onSendChat(desc)}>
      <S.IconWrapper>
        <IconChatSupport width={24} height={24} />
        {/* <HVIcon name="chat-support" svgProps={{ ...ICON.SIZE_20 }} /> */}
      </S.IconWrapper>
      <S.CardText>
        <h3>{title}</h3>
        <p>{desc}</p>
      </S.CardText>
    </S.CardWrapper>
  );
};

export default Card;
